import { Link } from "react-router-dom";
import { PROMO_IMG } from "@/lib/api";
import { motion } from "framer-motion";

export default function SpecialOffer() {
  return (
    <section className="py-24 md:py-32 bg-black text-white relative overflow-hidden" data-testid="special-offer-section">
      <div className="absolute inset-0 opacity-30">
        <img src={PROMO_IMG} alt="Save 30% — BLISSON luxury beauty offer" loading="lazy" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/70 to-transparent" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-4 mb-5">
            <span className="w-14 h-px bg-[#C9A961]" />
            <span className="overline text-[#C9A961]">Limited Edition Ritual</span>
          </div>
          <h2 className="font-serif-display text-5xl md:text-7xl tracking-tighter font-light leading-[1.02]">
            The Salon Edit.
            <br />
            <em className="text-[#C9A961] not-italic">Up to 30% off.</em>
          </h2>
          <p className="text-base md:text-lg text-white/75 mt-6 max-w-xl leading-relaxed">
            Hand-curated salon-grade rituals — only until Sunday. Includes complimentary engraved gold-tone tools with orders over ₹3,999.
          </p>
          <div className="flex items-center gap-4 mt-9">
            <Link to="/shop" className="btn-gold" data-testid="offer-shop-now">
              Shop the Edit →
            </Link>
            <Link to="/shop" className="overline text-white/80 hover:text-[#C9A961] transition-colors" data-testid="offer-view-collection">
              View Collection
            </Link>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5 hidden lg:block"
        >
          <div className="border border-[#C9A961]/30 p-10 glass-dark">
            <div className="overline text-[#C9A961] mb-3">Code</div>
            <div className="font-serif-display text-5xl tracking-wider">BLISSON30</div>
            <div className="w-full h-px bg-white/15 my-6" />
            <div className="text-sm text-white/65">Apply at checkout. Valid on full-price salon edit only. Ends Sunday at midnight.</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
